import CloseIcon from "@hub/assets/close.svg";
import { FilterCategoryDisplayName } from "@hub/data/values/data-values.enum";
import { ContentFilteringService } from "@hub/services/filtering/content-filtering.service";
import { useContentFiltering } from "@hub/services/use-content-filtering";
import { ButtonVariant } from "@hub/values/button-variant.enum";
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "../buttons/button";
import { FilterCategory } from "./filter-category";
import styles from "./filters-modal.module.css";

export const FiltersModal: React.FC = () => {
  const {
    enabledFilterGroups,
    availableFilterOptions,
    typeFilterValues,
    frameworkFilterValues,
    languageFilterValues,
    topicFilterValues,
    handleTypeFilter,
    handleLanguageFilter,
    handleFrameworkFilter,
    handleTopicFilter,
    handleClearFilters,
    closeModal,
  } = useContentFiltering();

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  useEffect(() => {
    const isModalVisibleSub = ContentFilteringService.isModalVisible$.subscribe(
      (data) => {
        setIsModalVisible(data);
      }
    );

    return () => {
      if (isModalVisibleSub) {
        isModalVisibleSub.unsubscribe();
      }
    };
  }, []);

  const closeFilters = useCallback(() => {
    closeModal();
  }, [closeModal]);

  if (!availableFilterOptions || !enabledFilterGroups) {
    return null;
  }

  const {
    typeOptions,
    frameworkOptions,
    DocumentPickerLanguageOptions,
    topicOptions,
  } = availableFilterOptions;

  const handleApplyFilters = () => {
    closeFilters();
  };

  return (
    <div
      className={`${styles.filtersModal} ${
        isModalVisible ? styles.open : styles.closed
      }`}
    >
      <div className={styles.header}>
        <button className={styles.closeButton} onClick={closeFilters}>
          <CloseIcon />
        </button>
      </div>
      <div className={styles.content}>
        {enabledFilterGroups.topic && (
          <FilterCategory
            categoryName={FilterCategoryDisplayName.Topic}
            options={topicOptions}
            selectOption={handleTopicFilter}
            filterValues={topicFilterValues}
          />
        )}
        {enabledFilterGroups.type && (
          <FilterCategory
            categoryName={FilterCategoryDisplayName.Type}
            options={typeOptions}
            selectOption={handleTypeFilter}
            filterValues={typeFilterValues}
          />
        )}
        {enabledFilterGroups.language && (
          <FilterCategory
            categoryName={FilterCategoryDisplayName.Language}
            options={DocumentPickerLanguageOptions}
            selectOption={handleLanguageFilter}
            filterValues={languageFilterValues}
          />
        )}
        {enabledFilterGroups.framework && (
          <FilterCategory
            categoryName={FilterCategoryDisplayName.Framework}
            options={frameworkOptions}
            selectOption={handleFrameworkFilter}
            filterValues={frameworkFilterValues}
          />
        )}
      </div>
      <div className={styles.footer}>
        <Button
          variant={ButtonVariant.SOLID}
          label="Apply filters"
          onClick={handleApplyFilters}
        />
        <Button
          variant={ButtonVariant.OUTLINE}
          label="Clear filters"
          onClick={handleClearFilters}
        />
      </div>
    </div>
  );
};
